import api from "@/lib/api";

// urlBase64ToUint8Array (from Google's Push examples)
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

async function getRegistration() {
  const reg = await navigator.serviceWorker.ready;
  return reg;
}

export async function getCurrentSubscription() {
  if (!isPushSupported()) return null;
  try {
    const reg = await getRegistration();
    return await reg.pushManager.getSubscription();
  } catch (e) {
    return null;
  }
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Este navegador no soporta notificaciones push.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permiso de notificaciones denegado.");
  }
  const { data } = await api.get("/push/vapid-public-key");
  const publicKey = data.public_key;
  if (!publicKey) throw new Error("Servidor sin VAPID configurado.");
  const reg = await getRegistration();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  await api.post("/push/subscribe", {
    subscription: sub.toJSON(),
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  const endpoint = sub.endpoint;
  try {
    await sub.unsubscribe();
  } catch (e) {
    /* ignore */
  }
  try {
    await api.post("/push/unsubscribe", { endpoint });
  } catch (e) {
    /* ignore */
  }
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test");
  return data;
}
